import { Fragment as F } from 'react';
import RequiredSelect from '@corefact/toolchain/components/RequiredSelect';
import { theme, customStyles } from '../content/select-styles';
import { GET, POST, FetchUtils } from '@corefact/toolchain/fetch-utils';
import { Toggle } from '@corefact/toolchain/components/IconManager';
import ReCAPTCHA from 'react-google-recaptcha';
import {
    NotificationToasts,
    NotificationStore,
} from '@corefact/toolchain/components/Notifications';
import ENVConfig from 'configs/env-config';
import {
    Modal,
    CloseModal,
} from '@corefact/toolchain/components/BasicModal';
import StatesHash from '../content/states';
import TagEvent from './libs/TagEvent';
import Sqids from 'sqids';

FetchUtils.setDefaultOptions({
    retry: false, // Disable retries for all requests
})
FetchUtils.setDefaultURLParams({
    base: ENVConfig.APP_HOST,
    host: ENVConfig.API_HOST_V3,
});

function debounce(ctx = this, func, wait, immediate) {
    var timeout;
    return function () {
        var context = ctx, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

function getFlashCookie() {
    const match = document.cookie.match(/(?:^|;\s*)_flash=([^;]*)/);
    if (!match) return [];

    try {
        return JSON.parse(decodeURIComponent(match[1])) || [];
    } catch (e) {
        return [];
    }
}

function addFlashMessage(newMessage) {
    const flashArray = getFlashCookie();
    flashArray.push(newMessage);

    const encoded = encodeURIComponent(JSON.stringify(flashArray));
    document.cookie = `_flash=${encoded}; path=/`;
}

const FoundOptions = [
    { value: 'Title Rep Referral', label: 'Title Rep Referral', placeholder: 'Name of referrer', other: true, ref_token: true },
    { value: 'Friend / Co-worker', label: 'Friend / Co-worker' },
    { value: 'Web Search', label: 'Web Search' },
    { value: 'Google Ad', label: 'Google Ad' },
    { value: 'Facebook', label: 'Facebook' },
    { value: 'Instagram', label: 'Instagram' },
    { value: 'LinkedIn', label: 'LinkedIn' },
    { value: 'Event', label: 'Event' },
    { value: 'Other', label: 'Other', other: true },
]

const AccountTypes = [
    { value: 'Agent / Broker Associate', label: 'Agent / Broker Associate', office: true },
    { value: 'Branch Manager / Broker', label: 'Branch Manager / Broker', office: true },
    { value: 'Coordinator / Assistant', label: 'Coordinator / Assistant', office: false },
    { value: 'Mortgage Professional', label: 'Mortgage Professional', office: false },
    { value: 'Title Executive', label: 'Title Executive', office: false },
    { value: 'General Business', label: 'General Business', office: false },
    { value: 'Other', label: 'Other', office: false, other: true },
]

const StateOptions = Object.entries(StatesHash).map(([value, label]) => ({
    value,
    label,
}));

if (!window.initialSearch) {
    window.initialSearch = new URLSearchParams(document.location.hash?.match?.(/\?(.*)/)?.[1] || document.location.hash?.replace?.(/^#\/??[^?]/, ''))
}

export default class SignUp extends CoreComponent {
    constructor(props) {
        super(props);
        this.state = {
            tos: false,
            addOffice: false,
            offices: null,
            newOffice: false,
            officeState: false,
            referral: {
                first_name: window.initialSearch.get('first_name') || undefined,
                last_name: window.initialSearch.get('last_name') || undefined,
                email: window.initialSearch.get('email') || undefined,
                mobile_phone: window.initialSearch.get('mobile_phone') || undefined,
            },
            formkey: new Date().getTime(),
            fromAdClickObject: null,
        }

        // Get the ad clock object
        GET('{ base }/router/cookie.json', {}).then((resp) => {
            if (resp?.success) {
                let { id, path, provider } = resp?.attributes || {};
                this.setStatePrev({
                    fromAdClickObject: {
                        path,
                        provider,
                        token: id,
                    },
                });
            } else {
                console.warn(resp);
            }
        });

        this.NotificationStore = new NotificationStore();

        // Sign up refs
        this.signupFormRef = React.createRef();
        this.emailRef = React.createRef();
        this.passwordRef = React.createRef();
        this.confirmPasswordRef = React.createRef();
        this.firstNameRef = React.createRef();
        this.lastNameRef = React.createRef();
        this.phoneRef = React.createRef();
        this.iAmRef = React.createRef();
        this.foundRef = React.createRef();
        this.tosRef = React.createRef();
        this.recaptchaRef = React.createRef();
        this.recapRef = React.createRef();
        this.fromAdClickRef = React.createRef();

        // Add office refs
        this.officeFormRef = React.createRef();
        this.officeNameRef = React.createRef();
        this.officeAddressRef = React.createRef();
        this.officeAddress2Ref = React.createRef();
        this.officeCityRef = React.createRef();
        this.officeStateRef = React.createRef();
        this.officeZipRef = React.createRef();
        this.fullAddress = React.createRef();

        this.officeState = React.createRef();
    }

    componentDidMount() {
        GET('{ host }/signup/office_states', {}).then(({ states = null }) => {
            this.setStatePrev({
                states: (states || []).map(([state, abbr]) => ({ value: abbr, label: state })),
            });
        });
        if (window.initialSearch?.get?.('ref_token')) {
            GET('{ base }/referred_accounts/find_by_token', {
                searchParams: { ref_token: window.initialSearch.get('ref_token') },
            }).then((resp) => this.setStatePrev({
                referral: resp,
                formkey: new Date().getTime(),
            }));
        }
    }

    submit() {
        if (![
            this.validateRecaptcha(),
            this.validateFistName(),
            this.validateLastName(),
            this.validateEmail(),
            this.validatePassword(),
            this.validateConfirmPassword(),
            this.validatePhone(),
            this.validateTOS(),
            this.validateIamAn(),
            window.initialSearch?.get?.('ref_token')?.length > 0 ? true : this.validateFrom(),
        ].every(Boolean)) {
            this.safeForceUpdate();
            this.signupFormRef?.current?.checkValidity?.();
            return
        }

        var packet = clean({
            user: {
                login: this.emailRef.current.value,
                password: this.passwordRef.current.value,
                password_confirmation: this.confirmPasswordRef.current.value,
            },
            agent: clean({
                full_name: `${this.firstNameRef.current.value} ${this.lastNameRef.current.value}`,
                phone: this.phoneRef.current.value,
                i_am_an: (this.iAmRef.current?.value || this.state.iAmOption?.value || undefined),
                found: (this.foundRef.current?.value || this.state.foundOption?.value || undefined),
                ref_token: (window.initialSearch.get('ref_token') || undefined),
                ref_agent: decode(window.initialSearch.get('ref_agent')), // Decode
                agreed_to_tos: this.state.tos || false,
                mobile_opt_in: this.state.mobile_accept || false,
                from_ad_click: this.fromAdClickRef.current?.value || undefined,
            }),
            'g-recaptcha-response': this.recaptchaRef.current.getValue() || undefined,
        });

        if (this.state.iAmOption.office) {
            if (this.state.newOffice) {
                packet = {
                    ...packet,
                    new_office: this.state.newOffice,
                }
            } else if (this.state.selectedOffice) {
                packet = {
                    ...packet,
                    agent: {
                        ...(packet.agent || {}),
                        'marketing_office_id': this.state.selectedOffice.marketing_office_id || this.state.selectedOffice.office_id,
                    },
                }
            } else {
                return this.NotificationStore.add({
                    message: 'You must either choose an existing office or add a new one.',
                    type: 'error',
                    position: 'top-center',
                    timeout: 5000,
                }).then(() => this.safeForceUpdate())
            }
        }

        POST('{ host }/signup/', {
            body: packet,
        }).then((resp) => {
            if (!resp.success || ('errors' in resp)) {
                return Promise.reject(resp);
            } else if (this.state.fromAdClickObject) {
                TagEvent('signup_ad_click', {
                    agent_id: resp.agent_id,
                    ...(this.state.fromAdClickObject || {}),
                }).finally(() => {
                    window.location = '/print/users/current/edit'
                });
            } else {
                window.location = '/print/users/current/edit'
            }
        }).catch((err) => {
            (Array.isArray(err.errors) ? err.errors : ['There was an unknown error, please try again.']).map((err) => {
                this.NotificationStore.add({
                    message: err,
                    type: 'error',
                    position: 'top-center',
                    timeout: 5000,
                })
            })
            this.safeForceUpdate();
        });
    }

    newOffice() {
        if (![
            this.validateOfficeName(),
            this.validateOfficeAddress(),
            this.validateOfficeCity(),
            this.validateOfficeZip(),
            this.validateOfficeState(),
        ].every(Boolean)) {
            this.safeForceUpdate();
            this.officeFormRef?.current?.checkValidity?.();
            return Promise.reject();
        }
        return this.setStatePrev({
            newOffice: {
                office_name: this.officeNameRef.current.value,
                office_full_address: [
                    this.officeAddressRef.current.value,
                    this.officeAddress2Ref.current.value,
                ].filter(val => val && String(val).trim().length >= 1).join(' '),
                city: this.officeCityRef.current.value,
                state: this.officeStateRef.current.value,
                office_zip: this.officeZipRef.current.value,
            },
        });
    }

    validateRecaptcha() {
        this.recapRef.current.setCustomValidity('');
        this.recapRef.current.checkValidity();
        if (!this.recapRef.current.checked) {
            this.recapRef.current.setCustomValidity('You must prove you\'re not a robot.');
        }
        this.recapRef.current.reportValidity();

        return this.recapRef.current.checkValidity();
    }

    validateTOS() {
        this.tosRef.current.setCustomValidity('');
        this.tosRef.current.checkValidity();
        if (!this.tosRef.current.checked) {
            this.tosRef.current.setCustomValidity('You must first agree to the terms of service.');
        }
        this.tosRef.current.reportValidity();

        return this.tosRef.current.checkValidity();
    }

    validateIamAn() {
        this.iAmRef.current.setCustomValidity('');
        this.iAmRef.current.checkValidity();
        if (this.iAmRef.current.value.length < 2) {
            this.iAmRef.current.setCustomValidity('You must provide an answer for this field.');
        }
        this.iAmRef.current.reportValidity();

        return this.iAmRef.current.checkValidity();
    }

    validateFrom() {

        // Check if foundRef exists
        if (this.foundRef?.current) {
            this.foundRef.current.setCustomValidity('');
            this.foundRef.current.checkValidity();
            if (this.foundRef.current.value.length < 2) {
                this.foundRef.current.setCustomValidity('You must provide an answer for this field.');
            }
            this.foundRef.current.reportValidity();

            return this.foundRef.current.checkValidity();
        }
        return true
    }


    validateFistName() {
        this.firstNameRef.current.setCustomValidity('');
        this.firstNameRef.current.checkValidity();
        if (this.firstNameRef.current.value.length < 2) {
            this.firstNameRef.current.setCustomValidity('First name must be at least 2 characters long.');
        }
        this.firstNameRef.current.reportValidity();

        return this.firstNameRef.current.checkValidity();
    }

    validateLastName() {
        this.lastNameRef.current.setCustomValidity('');
        this.lastNameRef.current.checkValidity();
        if (this.lastNameRef.current.value.length < 2) {
            this.lastNameRef.current.setCustomValidity('Last name must be at least 2 characters long.');
        }
        this.lastNameRef.current.reportValidity();

        return this.lastNameRef.current.checkValidity();
    }


    validateEmail() {
        var email = this.emailRef.current.value;
        this.emailRef.current.setCustomValidity('');
        this.emailRef.current.checkValidity();
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            GET('{ host }/signup/validate_email', { searchParams: { 'user[login]': email, 'check_duplicates': 1 } }).then((response) => {
                if (!response.valid_email) {
                    if (response.multiaccount) {
                        addFlashMessage({ message: 'We have detected more than one account associated with your username or email. Please request a code and enter the OTP sent to your email to proceed.', status: 'success' })
                        window.location.href = `/login/otp?email=${email}`
                    } else {
                        this.emailRef?.current?.setCustomValidity?.('Account exists, please sign in.');
                    }
                }
                this.emailRef?.current?.reportValidity?.();
            });
        } else {
            this.emailRef.current.reportValidity();
        }

        return this.emailRef.current.checkValidity();
    }

    validatePhone() {
        if (!/^(\+?1[\s-]?)?\(?[0-9]{3}\)?[\s-]?[0-9]{3}[\s-]?[0-9]{4}$/.test(this.phoneRef.current.value)) {
            this.phoneRef.current.setCustomValidity('This must be a valid US phone number.');
        } else {
            this.phoneRef.current.setCustomValidity('');
        }
        this.phoneRef.current.reportValidity();

        return this.phoneRef.current.checkValidity();
    }

    validatePassword() {
        this.passwordRef.current.setCustomValidity('');
        this.passwordRef.current.checkValidity();
        var len = this.passwordRef.current.value.length;
        if (len < 8 || len > 40) {
            this.passwordRef.current.setCustomValidity('Password must be between 8 and 40 characters.');
        } else if (!/(\d+.*[a-z]|[a-z]+.*\d)/i.test(this.passwordRef.current.value)) {
            this.passwordRef.current.setCustomValidity('Password must contain at least one number and one letter.');
        }
        this.passwordRef.current.reportValidity();

        return this.passwordRef.current.checkValidity();
    }

    validateConfirmPassword() {
        this.confirmPasswordRef.current.setCustomValidity('');
        this.confirmPasswordRef.current.checkValidity();
        if (this.passwordRef.current.value !== this.confirmPasswordRef.current.value) {
            this.confirmPasswordRef.current.setCustomValidity('Passwords do not match.');
        }
        this.confirmPasswordRef.current.reportValidity();

        return this.confirmPasswordRef.current.checkValidity();
    }

    validateOfficeName() {
        this.officeNameRef.current.setCustomValidity('');
        this.officeNameRef.current.checkValidity();
        if (this.officeNameRef.current.value.length < 2) {
            this.officeNameRef.current.setCustomValidity('Office name must be at least 2 characters long.');
        }
        this.officeNameRef.current.reportValidity();

        return this.officeNameRef.current.checkValidity();
    }

    validateOfficeAddress() {
        this.officeAddressRef.current.setCustomValidity('');
        this.officeAddressRef.current.checkValidity();
        if (this.officeAddressRef.current.value.length < 2) {
            this.officeAddressRef.current.setCustomValidity('Office address must be at least 2 characters long.');
        }
        this.officeAddressRef.current.reportValidity();

        return this.officeAddressRef.current.checkValidity();
    }

    validateOfficeCity() {
        this.officeCityRef.current.setCustomValidity('');
        this.officeCityRef.current.checkValidity();
        if (this.officeCityRef.current.value.length < 2) {
            this.officeCityRef.current.setCustomValidity('Office city must be at least 2 characters long.');
        }
        this.officeCityRef.current.reportValidity();

        return this.officeCityRef.current.checkValidity();
    }

    validateOfficeState() {
        this.officeStateRef.current.setCustomValidity('');
        this.officeStateRef.current.checkValidity();
        if (!(this.officeStateRef.current.value in StatesHash)) {
            this.officeStateRef.current.setCustomValidity('You must select a state for your office.');
        }
        this.officeStateRef.current.reportValidity();

        return this.officeStateRef.current.checkValidity();
    }

    validateOfficeZip() {
        this.officeZipRef.current.setCustomValidity('');
        this.officeZipRef.current.checkValidity();
        var zip = String(this.officeZipRef.current.value).trim();
        if (!/^[0-9]{5}$/.test(zip)) {
            this.officeZipRef.current.setCustomValidity('Invalid zip code, please try again.');
        }
        this.officeZipRef.current.reportValidity();

        return this.officeZipRef.current.checkValidity();
    }

    pullOffices() {
        GET('{ host }/signup/search_offices', {
            searchParams: {
                state: this.state.officeState.value,
                search_term: this.state.officeFullAddress.office_full_address,
            },
        }).then((response) => {
            if (!response.success || response.offices.length === 0) {
                this.setStatePrev({
                    selectedOffice: null,
                    offices: null,
                })
            } else {
                this.setStatePrev({
                    selectedOffice: null,
                    offices: response.offices,
                })
            }
        }).catch(console.trace);
    }

    autoComplete(input, cb) {
        if (input && this.state.officeState) {
            clearTimeout(this.autoCompleteTimer);
            this.autoCompleteTimer = this.setTimeout(() => {
                GET('{ host }/signup/search_offices', {
                    searchParams: {
                        state: this.state.officeState.value,
                        search_term: input,
                    },
                }).then((resp) => {
                    this.setStatePrev({
                        updated: Date.now(),
                    }).then(() => {
                        cb(resp.offices.map((o) => {
                            return {
                                ...o,
                                label: o.office_full_address,
                                value: o.office_id || o.office_full_address,
                            }
                        }));
                    })
                })
            }, 400);
        }

    }

    render() {
        var refAgent = this.state.referral?.agent !== undefined && !this.state.referral?.expired;

        return (
            <>
                <div className="SignUp">
                    <h1>
                        Sign Up Today!
                    </h1>

                    {
                        (this.state.referral?.expired || this.state.referral?.error) && (
                            <p className="expired">
                                We regret to inform you that your referral link has expired or is invalid. Please contact&nbsp;
                                {this.state.referral?.agent?.name || 'the referring agent'}
                                {this.state.referral?.agent?.email ? <>&nbsp;at <a href={`mailto:${this.state.referral?.agent?.email}`}>{this.state.referral?.agent?.email}</a></> : ''}
                                &nbsp;for a new referral invitation.
                            </p>
                        )
                    }

                    <form ref={this.signupFormRef} key={this.state.formkey}>
                        {
                            this.state.fromAdClickObject && (
                                <input type="hidden" ref={this.fromAdClickRef} name="from_ad_click" value={this.state.fromAdClickObject?.token} />
                            )
                        }
                        <div className="flexboxgrid between-xs">
                            <div className="fbg-row col-xs-12">
                                <div className="col-xs-12 col-sm-6">
                                    <div className="label">First Name</div>
                                    <input type="text" required ref={this.firstNameRef} onChange={debounce(this, this.validateFistName, 100)} defaultValue={this.state.referral?.first_name} />
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <div className="label">Last Name</div>
                                    <input type="text" required ref={this.lastNameRef} onChange={debounce(this, this.validateLastName, 100)} defaultValue={this.state.referral?.last_name} />
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <div className="label">Email</div>
                                    <input type="email" autoComplete="off" required ref={this.emailRef} onChange={debounce(this, this.validateEmail, 500)} defaultValue={this.state.referral?.email} />
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <div className="label">Phone</div>
                                    <input type="tel" className="phone" autoComplete="off" name="agent[phone]" required ref={this.phoneRef} onChange={debounce(this, this.validatePhone, 100)} defaultValue={this.state.referral?.mobile_phone} />
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <div className="label">Password</div>
                                    <input type="password" required ref={this.passwordRef} onChange={debounce(this, this.validatePassword, 100)} />
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <div className="label">Confirm Password</div>
                                    <input type="password" required ref={this.confirmPasswordRef} onChange={debounce(this, this.validateConfirmPassword, 100)} />
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <div className="label">I am a/an:</div>
                                    <RequiredSelect
                                        styles={customStyles}
                                        options={AccountTypes}
                                        theme={theme}
                                        placeholder=""
                                        onChange={
                                            (option) => {
                                                this.setStatePrev({
                                                    iAmOption: option,
                                                    iAmValue: String(option.value).toLocaleLowerCase(),
                                                }).then(() => {
                                                    if (!this.state.iAmOption?.other) {
                                                        this.iAmRef.current.value = option.value;
                                                    }
                                                })
                                            }
                                        }
                                        inputRef={this.state.iAmOption?.other ? null : this.iAmRef}
                                    />
                                    {
                                        this.state.iAmOption?.other && (<input type="text" placeholder={this.state.iAmOption?.placeholder || ''} style={{ marginTop: '8px' }} ref={this.iAmRef} />)
                                    }
                                </div>

                                <div className="col-xs-12 col-sm-6" style={{ zIndex: 10, visibility: refAgent ? 'hidden' : '' }}>
                                    <div className="label">I found Corefact through...</div>
                                    <RequiredSelect
                                        fallback="Loading..."
                                        isDisabled={refAgent}
                                        styles={customStyles}
                                        options={FoundOptions}
                                        theme={theme}
                                        placeholder=""
                                        defaultValue={refAgent ? FoundOptions.find((o) => o.ref_token).value : undefined}
                                        onChange={
                                            (option) => {
                                                this.setStatePrev({
                                                    foundOption: option,
                                                    foundValue: option.value,
                                                });
                                            }
                                        }
                                        inputRef={this.state.foundOption?.other ? null : this.foundRef}
                                    />
                                    {
                                        this.state.foundOption?.other && (
                                            <input
                                                type="text"
                                                defaultValue={this.state.foundOther}
                                                placeholder={this.state.foundOption.placeholder || ''} style={{ marginTop: '8px' }}
                                                required
                                                ref={this.foundRef}
                                                onChange={() => { this.setStatePrev({ foundOther: this.foundRef.current.value }) }}
                                            />
                                        )
                                    }
                                </div>

                                {
                                    this.state.iAmOption?.office ?
                                        <F>
                                            <div className="col-xs-12 fbg-row" style={{ paddingRight: 0 }}>
                                                <div className="label col-xs-12">Select by State and Office Name or Address</div>
                                                <div className="col-xs-4">
                                                    <RequiredSelect
                                                        placeholder=""
                                                        styles={customStyles}
                                                        theme={theme}
                                                        getOptionLabel={(o) => o.label}
                                                        value={this.state.officeState}
                                                        onChange={
                                                            (option) => {
                                                                this.setStatePrev({
                                                                    officeState: option,
                                                                })
                                                            }
                                                        }
                                                        selectedOffice={this.state.officeState}
                                                        options={this.state.states}
                                                        inputRef={this.officeState}
                                                    />
                                                </div>
                                                <div className="col-xs-8" style={{ paddingRight: 0 }}>
                                                    <RequiredSelect
                                                        onMenuOpen={() => {
                                                            this.setStatePrev({
                                                                officeMenuIsOpen: true,
                                                            })
                                                        }}
                                                        onMenuClose={() => {
                                                            this.setStatePrev({
                                                                officeMenuIsOpen: false,
                                                            })
                                                        }}
                                                        mode="async"
                                                        placeholder=""
                                                        styles={
                                                            {
                                                                ...customStyles,
                                                                indicatorSeparator: () => { },
                                                                dropdownIndicator: defaultStyles => ({
                                                                    ...defaultStyles,
                                                                    width: 0,
                                                                    '& svg': { opacity: 0 },
                                                                }),
                                                            }
                                                        }
                                                        theme={theme}
                                                        formatOptionLabel={
                                                            (o) => (this.state.officeMenuIsOpen ? `${o.office_name} - ${o.label}` : o.label)
                                                        }
                                                        loadOptions={
                                                            (str, cb) => { this.autoComplete(str, cb) }
                                                        }
                                                        value={this.state.officeFullAddress}
                                                        onChange={
                                                            (option) => {
                                                                this.setStatePrev({
                                                                    offices: null,
                                                                    selectedOffice: option,
                                                                })//.then(() => this.pullOffices(true))
                                                            }
                                                        }
                                                        inputRef={this.officeAddress}
                                                        isDisabled={!this.state.officeState}
                                                        classNamePrefix="office-selector"
                                                        noOptionsMessage={(e) => e.inputValue ? 'No options found.' : null}
                                                        isClearable={true}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                (this.state.offices?.length >= 1 || this.state.selectedOffice) && (
                                                    <div className="office-list col-xs-12">
                                                        {
                                                            this.state.offices?.length >= 1 && (
                                                                <div className="offices col-xs-12">
                                                                    {
                                                                        this.state.offices?.map?.((office) => {
                                                                            return (
                                                                                <div className="office" key={office.office_id} onClick={() => {
                                                                                    this.setStatePrev({
                                                                                        offices: null,
                                                                                        selectedOffice: office,
                                                                                    })
                                                                                }}>
                                                                                    <div className="office-name">{office.office_name}</div>
                                                                                    <div className="office-address">{office.office_full_address}</div>
                                                                                </div>
                                                                            );
                                                                        })
                                                                    }
                                                                </div>
                                                            )
                                                        }
                                                        {
                                                            this.state.selectedOffice && (
                                                                <span className="selected-office col-xs-12">
                                                                    <div className="title">
                                                                        Selected Office:
                                                                    </div>
                                                                    <div className="office">
                                                                        <div className="office-name">{this.state.selectedOffice.office_name}</div>
                                                                        <div className="office-address">{this.state.selectedOffice.office_full_address}</div>
                                                                    </div>
                                                                </span>
                                                            )
                                                        }
                                                    </div>
                                                )
                                            }
                                            {
                                                this.state.newOffice && (
                                                    <div className="office-list col-xs-12">
                                                        <span className="selected-office col-xs-12">
                                                            <div className="title">
                                                                Selected Office:
                                                            </div>
                                                            <div className="office">
                                                                <div className="office-name">{this.state.newOffice?.office_name}</div>
                                                                <div className="office-address">
                                                                    {
                                                                        [
                                                                            this.state.newOffice?.address_line_1,
                                                                            this.state.newOffice?.address_line_2,
                                                                            this.state.newOffice?.city,
                                                                            this.state.newOffice?.state,
                                                                            this.state.newOffice?.zip,
                                                                        ].filter(x => x).join(', ')
                                                                    }
                                                                </div>
                                                            </div>
                                                        </span>
                                                    </div>
                                                )
                                            }
                                            <div className="col-xs-12">
                                                <a href={window.location.hash} className="add-office-button" onClick={() => {
                                                    this.setStatePrev({
                                                        addOffice: true,
                                                        selectedOffice: undefined,
                                                    });
                                                }}>
                                                    <i className="cf-icon-circle-plus-fill" /> My office isn&apos;t listed, add a new one.
                                                </a>
                                            </div>
                                        </F> : null
                                }

                                <div className="col-xs-12">
                                    <div className="tos">
                                        <input className="tos-checkbox" type="checkbox" required ref={this.tosRef} style={{ float: 'left' }} onChange={debounce(this, this.validateTOS, 100)} />
                                        <Toggle
                                            on="cf-icon-square-check"
                                            off="cf-icon-square"
                                            onClick={
                                                (tos) => {
                                                    this.setStatePrev({
                                                        tos,
                                                    }).then(() => {
                                                        this.tosRef.current.checked = tos;
                                                        debounce(this, this.validateTOS, 100)();
                                                    })
                                                }
                                            }
                                        />
                                        I have read and accept the Corefact <a href="/print/tos#terms_of_service" target="_blank">Terms and Conditions</a> and <a href="/print/tos#privacy_policy" target="_blank">Privacy Policy</a>.
                                        <br />
                                        <Toggle
                                            on="cf-icon-square-check"
                                            off="cf-icon-square"
                                            onClick={
                                                (mobile_accept) => {
                                                    this.setStatePrev({
                                                        mobile_accept,
                                                    })
                                                }
                                            }
                                        />
                                        By entering my mobile number and checking this box I agree to opt in to receive Corefact Alerts, special offers and flash sales for SMS subscribers only. Text HELP to 26704 for help. Text STOP to 26704 to end. Msg&Data Rates May Apply. By opting in, I authorize Corefact to deliver SMS messages using an automatic telephone dialing system and I understand that I am not required to opt in as a condition of purchasing any property, goods, or services. By leaving this box unchecked you will not be opted in for SMS messages at this time.
                                    </div>
                                </div>
                                <div className="col-xs-12">
                                    <center>
                                        <ReCAPTCHA
                                            ref={this.recaptchaRef}
                                            sitekey={ENVConfig.recaptchaSiteKey}
                                            onChange={
                                                (value) => {
                                                    this.setStatePrev({
                                                        recaptchaError: false,
                                                        recaptchaToken: value,
                                                    }).then(() => this.recapRef.current.checked = value ? true : false)
                                                }
                                            }
                                        />
                                        <div className="col-xs-12" style={{ height: 0, marginTop: '-26px', marginBottom: '26px' }}>
                                            <center>
                                                <input className="recap-checkbox" type="checkbox" required ref={this.recapRef} />
                                            </center>
                                        </div>
                                    </center>
                                </div>
                                <div className="col-xs-12">
                                    <center>
                                        <button onClick={
                                            (e) => {
                                                e.preventDefault();
                                                this.submit();
                                            }
                                        }>Create My Account</button>
                                    </center>
                                </div>
                                <div className="col-xs-12">
                                    <center>
                                        <a href="/login/otp" className="secondary-links mb-2">
                                            Sign in using one-time passcode
                                        </a>
                                    </center>
                                    <center>
                                        <a href="#/" className="secondary-links">
                                            I want to sign in
                                        </a>
                                    </center>
                                </div>
                            </div>
                        </div>
                    </form>
                    {
                        this.state.addOffice && (
                            <Modal
                                style={
                                    {
                                        width: 'auto',
                                        minWidth: '350px',
                                        maxWidth: '650px',
                                        height: 'auto',
                                    }
                                }
                                onClose={
                                    () => this.setStatePrev({ addOffice: false })
                                }
                            >
                                <CloseModal relative />
                                <form ref={this.officeFormRef}>
                                    <div className="flexboxgrid add-office">
                                        <div className="fbg-row col-xs-5 header">
                                            <div className="fbg-row col-xs-12 center-xs title">
                                                Add An Office
                                            </div>
                                            <div className="fbg-row col-xs-12 center-xs subtitle">
                                                After submitting, we will confirm your office and have it added to our database.
                                            </div>
                                            <div className="col-xs-12">
                                                <div className="label">Office Name</div>
                                                <input type="text" required ref={this.officeNameRef} onChange={debounce(this, this.validateOfficeName, 100)} />
                                            </div>
                                            <div className="col-xs-12">
                                                <div className="label">Address Line 1</div>
                                                <input type="text" required ref={this.officeAddressRef} onChange={debounce(this, this.validateOfficeAddress, 100)} />
                                            </div>
                                            <div className="col-xs-12">
                                                <div className="label">Address Line 2</div>
                                                <input type="email" ref={this.officeAddress2Ref} />
                                            </div>
                                            <div className="col-xs-6">
                                                <div className="label">City</div>
                                                <input type="text" required ref={this.officeCityRef} onChange={debounce(this, this.validateOfficeCity, 100)} />
                                            </div>
                                            <div className="col-xs-3">
                                                <div className="label">State</div>
                                                <RequiredSelect
                                                    styles={customStyles}
                                                    options={StateOptions}
                                                    theme={theme}
                                                    placeholder=""
                                                    onChange={
                                                        (option) => {
                                                            this.officeStateRef.current.value = option.value;
                                                        }
                                                    }
                                                    inputRef={this.officeStateRef}
                                                />
                                            </div>
                                            <div className="col-xs-3">
                                                <div className="label">Zip</div>
                                                <input type="text" required ref={this.officeZipRef} onChange={debounce(this, this.validateOfficeZip, 100)} />
                                            </div>
                                            <div className="fbg-row col-xs-12 center-xs">
                                                <button onClick={
                                                    (e) => {
                                                        e.preventDefault();
                                                        this.newOffice().then(() => {
                                                            this.setStatePrev({
                                                                addOffice: false,
                                                            })
                                                        })
                                                    }
                                                }>Submit Office</button>
                                            </div>
                                            <div className="fbg-row col-xs-12 center-xs">
                                                <a href={window.location.hash} className="add-office-button" onClick={() => {
                                                    this.setStatePrev({
                                                        addOffice: false,
                                                    })
                                                }}>
                                                    Cancel and go back to select an office.
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </Modal>
                        )
                    }
                    <NotificationToasts
                        position='top-center'
                        toasts={this.NotificationStore.toArray()}
                        onRemove={
                            toast => this.NotificationStore.delete(toast).then(() => this.safeForceUpdate())
                        }
                    />
                </div>

                {
                    refAgent && (
                        <span className="ref-box">
                            <div className="referral-container mgrid-t-4">
                                <div className="referred-by-box">
                                    <p>REFERRED BY:</p>
                                </div>
                                <div className="worker-info-box">
                                    <div className="image-box">
                                        <img src={this.state.referral.agent.headshot} alt="agent" />
                                    </div>
                                    <div className="info-box">
                                        <p className="title-name">{this.state.referral.agent.name}</p>
                                        <p className="subtitle"></p>
                                        <p className="subtitle phone">{this.state.referral.agent.mobile_phone}</p>
                                        <p className="subtitle email">{this.state.referral.agent.email}</p>
                                    </div>
                                </div>
                                <div className="logo-box" id="logo_link">
                                    <img src={this.state.referral.agent.company_logo} alt="logo" />
                                </div>
                            </div>
                        </span>
                    )
                }
            </>
        );
    }
}

function clean(obj) {
    Object.keys(obj).forEach(key => obj[key] === undefined && delete obj[key])
    return obj;
}

function decode(inp) {
    try {
        let decoded = new Sqids().decode(inp);
        return decoded.length == 2 && decoded[0] == 2005 ? decoded[1] : undefined;
    } catch (e) {
        return undefined;
    }
}
